const formatCurrency = (value, locale, options) => {
  if (typeof value === "string") {
    value = Number(value);
  }
  return new Intl.NumberFormat(locale, { style: "currency", ...options }).format(value).replace(",00", ",\u2013").replace("kr", "").trim();
};
var formatCurrency_default = formatCurrency;
export {
  formatCurrency_default as default
};
